<template>
    <div >
        <section class="row pt-5">
            <b-col sm="12">
                <div class="form-horizontal">

                  <div class="form-group form-group-venue" >
                    <b-col sm="12">
                      <p class="lead text-center" v-html="$store.state.user.welcome_message"></p>
                    </b-col>
                  </div>

                  <div class="form-group form-group-venue" >
                    <b-col v-if="$store.state.user.show_honeymoon_itinerary" sm="12" >
                      <p class="lead text-center">
                        To view a preview of our Trailfinders honeymoon <br/><a :href="'https://www.trailfinders.com/viewtrail/viewtrail.html#/friendandfamily/' + $store.state.user.honeymoon_link " target="_blank">click here</a>.
                      </p>
                    </b-col>
                  </div>
                </div>
            </b-col>
        </section>
    </div> 
</template>

<script>

export default {
  data() {
    return {
      meta: {
        loaded: true
      },
 
    };
  },

  methods: {
  },
  mounted() {
    this.meta.loaded = true;
  },
};

</script>